module.exports = __webpack_public_path__ + "assets/img/img_2_8_2.98afc0dd.png";